import { useAuthContext } from "@/providers/auth-provider";
import { DownOutlined } from "@ant-design/icons";
import { Card, Dropdown, Flex, List, Space, Spin, theme, Typography } from "antd";
import { useTranslation } from "react-i18next";

export const RegionSelector = () => {
  const { token } = theme.useToken();
  const { t } = useTranslation();
  const { eks: { isLoading: isLoadingEks, isError, data: eks } } = useAuthContext();

  const items = eks?.regions ? eks.regions.map(region => ({
    key: region,
    label: `${t(`constants.regions.${region}.area`, region)} (${t(`constants.regions.${region}.city`)})`,
    onClick: () => console.log('Region:', region.id),
  })) : [];

  return (
    <Dropdown
      trigger={['click']}
      dropdownRender={menu => (
        <Card style={{ width: 300 }} size="small">
          <List
            size="small"
            dataSource={items}
            renderItem={item => (
              <List.Item
                onClick={(evt) => {
                  if (eks?.region === item.key) {
                    evt.preventDefault();
                    return;
                  }
                  const urlParams = new URLSearchParams(window.location.search);
                  const newUrl = new URL(`https://${item.key}.cloud.vitriadev.com`);
                  newUrl.search = urlParams.toString();
                  window.location.href = newUrl.toString();
                  evt.preventDefault();
                }}
                style={{ backgroundColor: eks?.region === item.key ? token.colorBgTextActive : '' }}
              >
                <a
                  href={`https://${item.key}.cloud.vitriadev.com`}
                  style={{ width: '100%' }}>
                  <Flex justify="space-between" align="center" style={{ width: '100%' }}>
                    <Typography.Text>{item.label}</Typography.Text>
                    <Typography.Text type="secondary">{item.key}</Typography.Text>
                  </Flex>
                </a>
              </List.Item>
            )}
          />
        </Card>
        )
      }
    >
      <a style={{ color: token.colorTextHeading }} onClick={(e) => e.preventDefault()}>
        <Space>
          {eks && t(`constants.regions.${eks.region}.city`, eks.region)}
          { isLoadingEks && <Spin size="small" /> }
          <DownOutlined />
        </Space>
      </a>
    </Dropdown>
  );
};